/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIDatasetWithPreviewPartialUpdate
 */
export interface AIDatasetWithPreviewPartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof AIDatasetWithPreviewPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AIDatasetWithPreviewPartialUpdate
     */
    type?: AIDatasetWithPreviewPartialUpdateTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AIDatasetWithPreviewPartialUpdate
     */
    connection?: number;
}

/**
* @export
* @enum {string}
*/
export enum AIDatasetWithPreviewPartialUpdateTypeEnum {
    Normal = 'normal',
    FaceLibrary = 'face-library',
    Stt = 'stt'
}

export function AIDatasetWithPreviewPartialUpdateFromJSON(json: any): AIDatasetWithPreviewPartialUpdate {
    return AIDatasetWithPreviewPartialUpdateFromJSONTyped(json, false);
}

export function AIDatasetWithPreviewPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIDatasetWithPreviewPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'connection': !exists(json, 'connection') ? undefined : json['connection'],
    };
}

export function AIDatasetWithPreviewPartialUpdateToJSON(value?: AIDatasetWithPreviewPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': value.type,
        'connection': value.connection,
    };
}


